<script>
import EmployeeManagementToggleAll from '@/components/profile/administrationManagement/EmployeeManagementToggleAll.vue'
import AdministrationManagementTableAction
  from '@/components/profile/administrationManagement/AdministrationManagementTableAction.vue'
import EmployeeManagementStatusIcon
  from '@/components/profile/administrationManagement/EmployeeManagementStatusIcon.vue'
import AdministratorToggle from '@/components/backoffice/organization/AdministratorToggle.vue'

export default {
  components: {
    AdministratorToggle,
    ToggleAll: EmployeeManagementToggleAll,
    TableAction: AdministrationManagementTableAction,
    StatusIcon: EmployeeManagementStatusIcon
  },
  props: {
    employees: {
      type: Array,
      required: false
    },
    organization: {
      type:Object
    }
  },
  data: vm => ({
    search: '',
    loading: false,
    toggleLoading: false,
    userSettingsToggle: { state: false, item: {} },
    hasInput: vm.$permissions.hasInput,
    selected: [],
    selectedItem: {},
    headers: [
      {
        text: vm.$t('global.status'),
        align: 'start',
        value: 'isAdmin'
      },
      {
        text: vm.$t('global.status'),
        align: 'start',
        value: 'status'
      },
      {
        text: vm.$t('form.label.first.name'
        ),
        align: 'start',
        filterable: true,
        value: 'firstName'
      },
      {
        text: vm.$t('form.label.last.name'),
        align: 'start',
        filterable: true,
        value: 'lastName'
      },
      {
        text: vm.$t('global.email.hyphen'),
        align: 'start',
        filterable: true,
        value: 'email'
      },
      {
        text: vm.$t('component.backoffice.userManagementTable.column.header.settings'),
        align: 'center',
        width: '80px',
        value: 'userSettings',
        sortable: false
      },
      {
        text: vm.$t('component.backoffice.userManagementTable.column.header.lock.user.settings'),
        align: 'end',
        width: '80px',
        value: 'userSettingsLocked',
        sortable: false,
        apiName: 'lockUserSettings'
      },
      {
        text: vm.$t('component.backoffice.userManagementTable.column.header.merge'),
        align: 'end',
        width: '80px',
        value: 'orgaMergeEnabled',
        sortable: false,
        apiName: 'setOrgaMerge'
      },
      {
        text: vm.$t('global.action'),
        align: 'end',
        value: 'action',
        sortable: false
      }
    ],
    members: [],
    tableAction: {
      resendInvitation: {
        confirmationContent: 'component.profile.administrationManagement.resend.invitation',
        tooltip: 'component.profile.administrationManagement.send.invitation'
      },
      cancelInvitation: {
        confirmationContent: 'component.profile.administrationManagement.delete.invitation',
        tooltip: 'component.profile.administrationManagement.cancel.invitation'
      },
      deleteUser: {
        confirmationContent: 'component.profile.administrationManagement.delete.user.info',
        tooltip: 'component.profile.administrationManagement.delete.user'
      },
      cancelRejectedInvitation: {
        confirmationContent: 'component.profile.administrationManagement.remove.entry',
        tooltip: 'component.profile.administrationManagement.delete.entry'
      },
      orgaMerge: {
        tooltip: 'component.profile.administrationManagement.cross.employee'
      }
    }
  }),
  computed: {
    accepted() {
      return status => status === this.$enums.InvitationStatus.Accepted
    },
    acceptedMember() {
      return this.members.filter(
        member => member.status === this.$enums.InvitationStatus.Accepted
      )
    },
    memberState() {
      return prop => {
        const acceptedMember = this.acceptedMember
        const filteredMember = this.filterMember(acceptedMember, prop)
        if (filteredMember.length === acceptedMember.length) {
          return true // All member locked
        } else {
          // null if some member locked, false if none member locked
          return filteredMember.length ? null : false
        }
      }
    }
  },
  watch: {
    employees: {
      handler: function(val) {
        this.members = val
      },
      deep: true
    }
  },
  created() {
    if (this.$props.employees) {
      this.members = this.$props.employees
    } else {
      this.getInvitedPeople()
    }
  },
  methods: {
    filterMember(members, prop) {
      return members.filter(member => member[prop])
    },
    getInvitedPeople() {
      this.loading = true
      this.$organizationService
        .invitedPeople(this?.organization?.id)
        .then(members => {
          this.members = members
          this.userInboxes = members.map(m => {
            return { id: m.id, inboxes: m.inboxes }
          })
        })
        .catch(() => {
          this.$notify(this.$t('component.profile.administrationManagement.get.invited.people.error'), { type: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async resendInvitation(user) {
      const organizationId = this.organization.id || null
      await this.$organizationService
        .sendInvitation({
          email: user.email,
          envUrl: `${window.config.VUE_APP_BASE_URL}`
        }, organizationId)
        .then(() => {
          this.$notify(this.$t('global.resend.invitation.success'), { type: 'success' })
        })
        .catch(() => {
          this.$notify(this.$t('global.resend.invitation.error'), { type: 'error' })
        })
    },
    async cancelInvitation(user) {
      await this.$organizationService
        .deleteInvitation(user.id, this.organization.id)
        .then(() => {
          this.$notify(this.$t('global.cancel.invitation.success'), { type: 'success' })
          this.getInvitedPeople()
        })
        .catch(() => {
          this.$notify(this.$t('global.cancel.invitation.error'), { type: 'error' })
        })
    },
    async deleteUser(user) {
      await this.$organizationService
        .deleteUser(user.id, this.organization.id)
        .then(() => {
          this.$notify(this.$t('global.delete.user.success'), { type: 'success' })
          this.getInvitedPeople()
        })
        .catch(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.delete.user.error'), { type: 'error' })
        })
    },
    async lockUserSettings(user) {
      await this.$userService
        .lockUserSettings({
          id: user.id,
          locked: user.userSettingsLocked
        })
        .then(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.lock.user.success'), { type: 'success' })
        })
        .catch(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.lock.user.error'), { type: 'error' })
        })
    },
    async changeOrgaMergeEnabled(user) {
      await this.$userService
        .setOrgaMerge({
          id: user.id,
          enabled: user.orgaMergeEnabled
        })
        .then(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.orga.merge.success'), { type: 'success' })
        })
        .catch(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.orga.merge.error'), { type: 'error' })
        })
    },
    async handleToggle(event, apiName) {
      this.toggleLoading = true
      await this.$organizationService[apiName](event)
        .then(async () => {
          await this.getInvitedPeople()
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.lock.user.success'), { type: 'success' })
        })
        .catch(() => {
          this.$notify(this.$t('component.backoffice.userManagementTable.notification.lock.user.error'), { type: 'error' })
        })
        .finally(() => {
          this.toggleLoading = false
        })
    },
    handleUserSettingsToggle(item) {
      this.userSettingsToggle.state = !this.userSettingsToggle.state
      this.userSettingsToggle.item = item
      this.$emit('onUserSettingsToggle', this.userSettingsToggle, this.$props.organization)
    },
  }
}
</script>
<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('global.search')"
          single-line
          hide-details>
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="members"
        :search="search"
        :loading="loading"
        :header-props="{
          sortByText: $t('global.search.label')
        }"
        :footer-props="{
          'items-per-page-text': $t('global.sort.by.text'),
          'items-per-page-all-text': $t('global.items.per.page.all.text'),
          'page-text': $t('global.page.text'),
          'items-per-page-options': [25, 50, 100]
        }"
        item-key="Id"
        class="elevation-1"
        fixed-header
        calculate-widths>
        <template #no-data>
          {{ $t('global.no.entries') }}
        </template>
        <template #[`header.isAdmin`]></template>
        <template #[`header.userSettings`]>
          <v-icon>mdi-cog</v-icon>
        </template>
        <template #[`header.userSettingsLocked`]="{ header }">
          <ToggleAll
            v-if="acceptedMember.length"
            :header="{value:header.value,text:'', icon:'mdi-lock'}"
            :state="memberState(header.value)"
            :loading="toggleLoading"
            @onToggle="handleToggle($event, header.apiName)" />
          <v-icon v-else>mdi-lock</v-icon>
        </template>
        <template #[`header.orgaMergeEnabled`]="{ header }">
          <ToggleAll
            v-if="acceptedMember.length"
            :header="{value:header.value,text:'',icon:'mdi-set-merge'}"
            :state="memberState(header.value)"
            :loading="toggleLoading"
            @onToggle="handleToggle($event, header.apiName)" />
          <v-icon v-else>mdi-set-merge</v-icon>
        </template>
        <template #[`item.isAdmin`]="{ item }">
          <AdministratorToggle :user="item" :organization="organization" @promote="item.isAdmin = !item.isAdmin" />
        </template>
        <template #[`item.status`]="{ item }">
          <StatusIcon :type="+item.status" />
        </template>
        <template #[`item.userSettingsLocked`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" class="d-flex justify-end">
            <v-simple-checkbox
              v-model="item.userSettingsLocked"
              @input="lockUserSettings(item)" />
          </div>
        </template>
        <template #[`item.userSettings`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" class="d-flex justify-center mt-2">
            <v-badge
              :color="item.userSettingsLocked ? 'error' : 'success'"
              :icon="item.userSettingsLocked ? 'mdi-lock' : 'mdi-lock-open'"
              bordered
              overlap>
              <v-btn icon @click="handleUserSettingsToggle(item)">
                <v-icon color="primary">mdi-account-cog</v-icon>
              </v-btn>
            </v-badge>
          </div>
        </template>
        <template #[`item.orgaMergeEnabled`]="{ item }">
          <div v-if="accepted(item.status) || item.isAdmin" class="d-flex justify-end">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-simple-checkbox
                  v-model="item.orgaMergeEnabled"
                  color="primary"
                  v-on="on"
                  @input="changeOrgaMergeEnabled(item)"
                ></v-simple-checkbox>
              </template>
              <span>{{ $t('component.profile.administrationManagement.cross.employee') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template #[`item.action`]="{ item }">
          <span v-if="item.status === $enums.InvitationStatus.Pending">
            <TableAction
              confirmation
              icon="mdi-email"
              @confirmed="resendInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.resend.invitation')">
                </span>
              </template>
              <template slot="tooltip">{{ $t('component.profile.administrationManagement.send.invitation') }}
              </template>
            </TableAction>
            <TableAction
              confirmation
              icon="mdi-close"
              color="error"
              @confirmed="cancelInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.delete.invitation')">
              </span>
              </template>
              <template slot="tooltip">{{ $t('component.profile.administrationManagement.cancel.invitation') }}</template>
            </TableAction>
          </span>
          <span>
            <TableAction
              confirmation
              icon="mdi-delete"
              color="error"
              @confirmed="deleteUser(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.delete.user')">
              </span>
              </template>
              <template slot="tooltip">{{ $t('component.profile.administrationManagement.delete.user') }}
              </template>
            </TableAction>
          </span>
          <span v-if="item.status === $enums.InvitationStatus.Rejected">
            <TableAction
              confirmation
              icon="mdi-close"
              color="error"
              @confirmed="cancelInvitation(item)">
              <template slot="confirmationContent">
                <span
                  v-html="$t('component.profile.administrationManagement.remove.entry')">
                </span>
              </template>
              <template slot="tooltip">{{ $t('component.profile.administrationManagement.delete.entry') }}</template>
            </TableAction>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
